import { useEffect } from "react";
import "./AnimalBloodDonor.css";

const AnimalBloodDonor = () => {
  useEffect(() => {
    document.title = "Animal Blood Donor | Find Animal Blood Donors";

    const description =
      "Find animal blood donors through Animal Blood Bank. Connect with a centralized animal blood donor network for dogs, cats, and other animals during emergencies.";

    // Description
    let meta = document.querySelector(
      'meta[name="description"]'
    ) as HTMLMetaElement | null;

    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.content = description;

    // Canonical URL
    let canonical = document.querySelector(
      'link[rel="canonical"]'
    ) as HTMLLinkElement | null;

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }

    canonical.href =
      "https://animalbloodbank.cloud/animal-blood-donor";
  }, []);

  return (
    <main className="animal-blood-donor-page">

      {/* Hero Section */}
      <section>
        <h1>Find Animal Blood Donors</h1>

        <p>
          Animal Blood Bank helps animal owners and veterinary professionals
          find suitable blood donors during emergency situations through a
          centralized animal blood donor database.
        </p>
      </section>

      {/* What is an animal blood donor */}
      <section>
        <h2>What is an Animal Blood Donor?</h2>

        <p>
          An animal blood donor is an eligible animal that can safely donate
          blood when another animal requires a blood transfusion. Suitable
          donors may be identified based on factors such as species, breed,
          blood group, health information, and location.
        </p>
      </section>

      {/* Finding donors */}
      <section>
        <h2>Find Suitable Animal Blood Donors</h2>

        <p>
          Finding a compatible animal blood donor during an emergency can be
          difficult when donor information is scattered across personal
          contacts, community groups, organizations, and social networks.
        </p>

        <p>
          Animal Blood Bank provides a centralized platform where eligible
          animal donors can be registered and managed, making it easier to
          identify potential donors when blood is urgently required.
        </p>
      </section>

      {/* Matching */}
      <section>
        <h2>How Animal Blood Donor Matching Works</h2>

        <ol>
          <li>
            Register an eligible animal as a potential blood donor.
          </li>

          <li>
            Maintain the animal's blood and profile information.
          </li>

          <li>
            Submit a blood request when an animal requires blood.
          </li>

          <li>
            Search for suitable donors based on species, breed, blood group,
            and other available information.
          </li>

          <li>
            Contact the selected donor owner to coordinate the donation.
          </li>
        </ol>
      </section>

      {/* Database */}
      <section>
        <h2>Why a Centralized Animal Blood Donor Database Matters</h2>

        <p>
          Veterinary hospitals and animal owners may struggle to find suitable
          donors quickly during emergency situations. A centralized donor
          database can help organize donor information and reduce the time
          required to search for potential animal blood donors.
        </p>
      </section>

      {/* Dogs */}
      <section>
        <h2>Dog Blood Donors</h2>

        <p>
          Dogs may require blood transfusions during serious medical
          emergencies. Finding an appropriate donor can be challenging when
          reliable donor information is not readily available. A centralized
          donor network can help veterinary professionals and animal owners
          identify potential dog blood donors.
        </p>
      </section>

      {/* Cats */}
      <section>
        <h2>Cat Blood Donors</h2>

        <p>
          Cats may also require blood transfusions in emergency situations.
          Maintaining organized donor information can help make the search for
          potential cat blood donors more efficient.
        </p>
      </section>

      {/* Animal Blood Bank */}
      <section>
        <h2>Animal Blood Bank</h2>

        <p>
          Animal Blood Bank is a centralized animal blood donor platform
          connecting animal owners, laboratories, and administrators to
          support better management of animal blood donor information and
          emergency blood requests.
        </p>
      </section>

    </main>
  );
};

export default AnimalBloodDonor;